import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '../shop-info/styles';

const VisitUs = ({
  title = 'Visit us',
  longAddressLine1,
  longAddressLine2,
  longAddressPostcode,
  longAddressTown,
}) => {
  const googleURL = encodeURI(
    `https://www.google.com/maps/search/?api=1&query=Shelter Charity Shop ${longAddressLine1}${
      longAddressLine2 ? ` ${longAddressLine2} ` : ''
    }${longAddressTown} ${longAddressPostcode}`
  );

  return (
    <div>
      {title && <Title>{title}</Title>}
      <address>
        {longAddressLine1}
        {longAddressLine2 ? (
          <>
            <br />
            {longAddressLine2}
          </>
        ) : null}
        <br />
        {longAddressTown}
        <br />
        {longAddressPostcode}
      </address>
      <p>
        <a target="_blank" rel="noreferrer noopener" href={googleURL}>
          Get directions
        </a>
      </p>
    </div>
  );
};

VisitUs.propTypes = {
  title: PropTypes.string,
  longAddressLine1: PropTypes.string.isRequired,
  longAddressLine2: PropTypes.string,
  longAddressPostcode: PropTypes.string.isRequired,
  longAddressTown: PropTypes.string.isRequired,
};

export default VisitUs;
